export const money = (n) => (typeof n === 'number' && Number.isFinite(n)
  ? n.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' })
  : '');

export const moneyShort = (n) => {
  if (typeof n !== 'number' || !Number.isFinite(n)) return '';
  const a = Math.abs(n);
  const sign = n < 0 ? '−' : '';
  if (a >= 1e6) return `${sign}£${(a / 1e6).toFixed(1)}m`;
  if (a >= 1e3) return `${sign}£${(a / 1e3).toFixed(a >= 1e4 ? 0 : 1)}k`;
  return `${sign}£${Math.round(a)}`;
};

const MONEY_KEY = /amount|balance|total|vat|remaining|difference|netassets|open amount|openamount/i;

// Render an example row generically — values are plain text only (no HTML).
export function exampleText(ex) {
  return Object.entries(ex)
    .filter(([, v]) => v !== null && v !== undefined && v !== '')
    .map(([key, v]) => {
      const k = key.replace(/([A-Z])/g, ' $1').toLowerCase(); // ageDays → age days
      if (Array.isArray(v)) return `${k}: ${v.join(', ')}`;
      if (typeof v === 'boolean') return `${k}: ${v ? 'yes' : 'no'}`;
      if (typeof v === 'number' && MONEY_KEY.test(key)) return `${k}: ${money(v)}`;
      return `${k}: ${v}`;
    })
    .join(' · ');
}
